export default {
  done: 'Done',
  cancel: 'Cancel',
};
